import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import { queryClient } from "@/lib/query-client";
import { initSentry, SentryErrorBoundary } from "@/lib/observability";
import { I18nProvider } from "@/i18n/provider";
import { router } from "@/app/router";
import "@/styles/globals.css";

initSentry();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No se encontró el elemento root");

createRoot(rootEl).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ resetError }) => (
        <div className="flex min-h-screen items-center justify-center bg-[#05070f] p-6 text-white">
          <div className="max-w-md space-y-4 text-center">
            <h1 className="text-2xl font-bold">Algo salió mal</h1>
            <p className="text-[14px] text-white/60">
              El error fue reportado al equipo. Recarga la página para volver al
              hospital virtual.
            </p>
            <button
              onClick={resetError}
              className="rounded-xl bg-[#2563eb] px-4 py-2 text-sm font-semibold hover:bg-[#1d4ed8]"
            >
              Recargar
            </button>
          </div>
        </div>
      )}
    >
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster position="top-right" richColors />
        </QueryClientProvider>
      </I18nProvider>
    </SentryErrorBoundary>
  </StrictMode>,
);
